import React, {Component} from 'react';
import { withStyles } from '@material-ui/core/styles';
//import BGImage from '../../../../../Utilities/default.jpg'
import CompositionContainer from './StaticPageEditComponet/CompositionContainer'
import EditFloatWindow from '../../../../FunctionArea/EditFloatWindow'
import ImageEditWindow from '../../../../FunctionArea/ImageEditWindow'
//import TextEditWindow from '../../../../FunctionArea/TextEditWindow'
import ContextMenu from '../../../../FunctionArea/ContextMenu'
import HyperLinkContainer from '../../../../FunctionArea/HyperLinkSelectorArea/HyperLinkContainer'

const wStyles = theme => ({
    appBarSpacer: theme.mixins.toolbar,
    content: {
        flexGrow: 1,
        height: '100vh',
        overflow: 'auto',
    },
    container: {
        paddingTop: theme.spacing(4),
        paddingBottom: theme.spacing(4),
    },
    paper: {
        padding: theme.spacing(2),
        display: 'flex',
        overflow: 'auto',
        flexDirection: 'column',
    },
    fixedHeight: {
        height: 240,
    },
    scrollContent1:{
        height:2000,
        width:200,
        backgroundColor:"#e6f542",
    },
    scrollContent2:{
        height:2000,
        width:200,
        backgroundColor:"#2e82ff",
    },
    scrollContainer:{
        //backgroundImage: `url(${BGImage})`,
        backgroundRepeat: "no-repeat",
        backgroundAttachment: "fixed",
        backgroundPosition: "center",
        backgroundSize: "cover",
        position:"relative",
        width:"100%",
       // height:"1000px",
        overflow:"hidden"
    },
    fixedUpHeader: {
        position:"sticky"
    },
    rightTopBoxArea:{
        position: "absolute",
        right: 2,
        top: 2,
        display: "flex",
    },
    textLinkLeft:{
        float:"left",
        height:40,
        color:"white",
        fontFamily:"Microsoft JhengHei",
        borderStyle:"soild",
        borderWidth:1,
        borderColor:"black",
        backgroundColor:"#2783c4",
        textAlign:"center",
        fontSize:20,
        lineHeight:"30px",
        margin:5,
        '&:hover':{
            color:"black",
        },
    },

    textLinkRight:{
        float:"right",
        height:40,
        color:"white",
        fontFamily:"Microsoft JhengHei",
        borderStyle:"soild",
        borderWidth:1,
        borderColor:"black",
        backgroundColor:"#2783c4",
        textAlign:"center",
        fontSize:20,
        lineHeight:"30px",
        margin:5,
        '&:hover':{
            color:"black",
        },
    },
    rightTopBox: {
        width:20,
        height:20,
        fontFamily: "Arial, Helvetica, sans-serif",
        cursor: "pointer",
        textAlign: "center",
        borderRadius: 5,
        backgroundColor:"#e6e6e6",
        color: "gray",
        '&:hover':{
            backgroundColor: "gray",
            color: "white",
        }
    },
    titleArea: {
        fontSize: 40,
        fontFamily: "Microsoft JhengHei",
    },
    input: {
        display: "none",
    },
});

class EditContent extends Component {
    constructor(props) {
        super(props)
        this.state = {
            layoutHeightNotFull:600,
            layoutHeightFull:800,
            mousePos:{
                x:0,
                y:0
            },
            refPos:{
                x:0,
                y:0
            },  
            EditFloatWindowPos:{
                x:0,
                y:0
            },
            needMousePos:false,
            editToken:false,
            showImageEditor:false,
            showTextEditor:false,
            showHyperLinkSelector:false,
            searchWord:null,
            newLink:null,
            editingCompositionID:null,
            contextManu:{
                status:false,
                pos:null,
                conID:0,
                command:null,
                from:null,
            },
            containerExtending:{
                status:false,
                conID:0,
            },
            containerDragging:{
                status:false,
                conID:0
            },
            bodySize:{
                width:0,
                height:0
            },
            compositionContainers:[]
        }
        this.openTempFile = React.createRef()
        this.scrollContainerLayout = React.createRef()   
        this.gridCanvas = React.createRef()
    }

    componentDidMount(){
        console.log("EditContent componentDidMount...")
        if(this.props.eventContent)
        {
            console.log("A1")
            if(this.props.eventContent[0])
            {
                console.log("A1-1")
                this.setState({
                    compositionContainers:this.props.eventContent
                })
            }
            else
            {
                console.log("A1-2")
            }
        }
        else
        {
            console.log("A2")
        }
        this.createGrid(10,"#34a4eb",2)
    }

    componentDidUpdate(prevProps,prevState){
        if(prevProps.eventContent !== this.props.eventContent)
        {
            if(this.props.eventContent)
            {
                console.log("A1")
                if(this.props.eventContent[0])
                {
                    console.log("A1-1")
                    this.setState({
                        compositionContainers:this.props.eventContent
                    })
                }
                else
                {
                    console.log("A1-2")
                }
            }
        }

        if(prevState.layoutHeightNotFull !== this.state.layoutHeightNotFull || prevState.layoutHeightFull !== this.state.layoutHeightFull)
        {
            this.createGrid(10,"#34a4eb",2)
        }
    }

    componentWillUnmount(){
        //this.sendCompositionContainersBack(false)
    }

    sendCompositionContainersBack=(token)=>{
        let size= {
            width:window.innerWidth,
            height:window.innerHeight
        }

        let msg = {
            editFinish:token,
            compositionContainers: this.state.compositionContainers,
            bodyHeight:this.state.layoutHeightFull,
            bodySize:size
        }

        this.props.getEventContent(msg)
    }

    getResizeWidth=()=>{
        let tempWidth = this.scrollContainerLayout.offsetWidth
        if(this.state.layoutWidth !== tempWidth)
        {
            this.setState({
                layoutWidth:tempWidth
            })
        }
    }

    createGrid=(gridGap, color, gap)=>{
        console.log("createGrid...")
        let ctx = this.gridCanvas.current.getContext("2d");
        ctx.lineWidth = 0.5;
        
        let canvasHeight = this.scrollContainerLayout.scrollHeight
        let canvasWidth = 2400

        console.log("canvasHeight : ",canvasHeight)
        console.log("canvasWidth : ",canvasWidth)
        for (let i = 0; i <= canvasHeight; i = i + gridGap) {
            ctx.beginPath();
            ctx.moveTo(0, i+0.5);
            ctx.lineTo(canvasWidth, i+0.5);

            if(i % 50 === 0)
            {
                ctx.font = "10px Arial"
                ctx.fillText(i, 0, i)
                ctx.fillStyle = "#bd0000"
                ctx.strokeStyle = "#ffa238"
            }
            else
            {
                ctx.strokeStyle = color;
            }
            ctx.closePath();
            ctx.stroke();
            
        }
        
          // vertical grid lines
        for (let j = 0; j <= canvasWidth; j = j + gridGap) {
            ctx.beginPath();
            ctx.moveTo(j+0.5, 0);
            ctx.lineTo(j+0.5, canvasHeight);

            if(j % 50 === 0)
            {
                ctx.font = "10px Arial"
                ctx.fillText(j, j, 10)
                ctx.fillStyle = "#bd0000"
                ctx.strokeStyle = "#ffa238"
            }
            else
            {
                ctx.strokeStyle = color;
            }
            ctx.closePath();
            ctx.stroke();
           
        }
    }

   

    openFileLoadingDialog = () => {
        this.openTempFile.current.click()
    }

    

    addImageContainer=()=>{
        //console.log("add new image container...")
        let msg = {
            type : "image"
        }
        this.addNewContainer(msg)
    }

    createContainer=()=>{
        //console.log("createContainer...")
        return(
            this.state.compositionContainers.map(container=>{
            // let pos1 = {
            //     x:this.state.EditFloatWindowPos.x+200,
            //     y:this.state.EditFloatWindowPos.y
            // }

            let pos2 = {
                x:container.x,
                y:container.y
            }
            
            let size = {
                width:container.width,
                height:container.height
            }

            return(
                <CompositionContainer key={container.conID} conID={container.conID} type={container.type} previewMode={false} previewSize={null} grouped={false}commonAttributes={container.commonAttributes} imageAttributes={container.imageAttributes} textAttributes={container.textAttributes} color={"grey"} divPos={pos2} mousePos={this.state.mousePos} size={size} containerExtending={this.onContainerExtending} containerDragging={this.onContainerDragging} focusingContainer={this.state.editingCompositionID} getContextMenu={this.getContextMenu} invokeImageEditor={this.invokeImageEditor} invokeTextEditor={this.invokeTextEditor} invokeHyperLinkSelection={this.invokeHyperLinkSelection} getStory={this.getText}/>
            )
        })
        )
    }

    invokeImageEditor=()=>{
        this.setState({
            showImageEditor:true
        })
    }

    invokeTextEditor=()=>{

        
        this.setState({
            showTextEditor:true
        })
    }

    invokeHyperLinkSelection=(msg)=>{
        console.log("EditContent invokeHyperLinkSelection")
        this.setState({
            showHyperLinkSelector:true,
            searchWord:msg,
            newLink:null
        })
    }

    getContextMenu=(msg)=>{
        this.setState({
            contextManu:{
                status:true,
                pos:msg.pos,
                conID:msg.conID,
                command:null,
                from:"contentContainer"
            }
        })
    }

    getCommand=(msg)=>{
        if(msg === "copy")
        {
            this.setState({
                contextManu:{
                    status:false,
                    pos:null,
                    conID:this.state.contextManu.conID,
                    command:msg,
                    from:null
                }
            })
        }
        else if(msg === "paste")
        {
            let output = []
            let tempContainer = {}
            let maxID = 0 
            this.state.compositionContainers.forEach(container=>{
                if(container.conID>maxID)
                {
                    maxID = container.conID
                }

                if(container.conID === this.state.contextManu.conID){
                    tempContainer = {
                        commonAttributes:container.commonAttributes,
                        conID:0,
                        height:container.height,
                        imageAttributes:container.imageAttributes,
                        textAttributes:container.textAttributes,
                        title:container.title,
                        type:container.type,
                        width:container.width,
                        x:this.state.contextManu.pos.x,
                        y:this.state.contextManu.pos.y,
                        zIndex:container.zIndex
                    }
                }

                output.push(container)
            })

            tempContainer.conID = maxID + 1
            output.push(tempContainer)

            this.setState({
                contextManu:{
                    status:false,
                    pos:null,
                    conID:0,
                    command:null,
                    from:null
                },
                compositionContainers:output
            })
        }
        else if(msg === "delete")
        {
            let output = []
            this.state.compositionContainers.forEach(container=>{
                if(container.conID === this.state.contextManu.conID)
                {
                }
                else
                {
                    output.push(container)
                }
            })

            this.setState({
                contextManu:{
                    status:false,
                    pos:null,
                    conID:0,
                    command:null,
                    from:null
                },
                compositionContainers:output
            })
        }
        else if(msg === "cancel")
        {
            this.setState({
                contextManu:{
                    status:false,
                    pos:null,
                    conID:0,
                    command:null,
                    from:null
                }
            })
        }
    }

    addTextContainer=()=>{
        //console.log("add new text container...")
        let msg = {
            type : "text"
        }
        this.addNewContainer(msg)
    }

    addNewContainer=(msg)=>{
        //let newID = this.state.compositionContainers.length +1
        let newID = 0
        if(this.state.compositionContainers.length === 0)
        {
            newID = 0
        }
        else
        {
            this.state.compositionContainers.forEach(container=>{
                if(container.conID>newID)
                {
                    newID = container.conID
                }
            })
        }

        let newContainerState = {}

        if(msg.type === "image")
        {
            newContainerState = {
                conID : newID+1,
                type : "image",
                title:"預設名稱",
                width : 200,
                height : 200,
                x:this.state.EditFloatWindowPos.x,
                y:this.state.EditFloatWindowPos.y,
                zIndex:0,
                commonAttributes:{
                    border:{
                        style:"none",
                        width:0,
                        color:"#ffffff"
                    },
                    background:{
                        color:"none",
                        opacity:100,
                    }, 
                },
                imageAttributes:{},
                textAttributes:{}
            }
        }
        else if(msg.type === "text")
        {
            newContainerState = {
                conID : newID+1,
                type : "text",
                title:"預設名稱",
                width : 200,
                height : 200,
                x:this.state.EditFloatWindowPos.x,
                y:this.state.EditFloatWindowPos.y,
                zIndex:0,
                commonAttributes:{
                    border:{
                        style:"none",
                        width:0,
                        color:"#ffffff"
                    },
                    background:{
                        color:"none",
                        opacity:100,
                    }, 
                },
                imageAttributes:{},
                textAttributes:{
                    background:{
                        color:"#ffffff",
                        opacity:100
                    },
                    font:{
                        cFamily:"none",
                        color:"#000000",
                        eFamily:"none",
                        size:12
                    },
                    story:null
                }
            }
        }

        let newStateArray = this.state.compositionContainers
        newStateArray.push(newContainerState)

        this.setState({
            compositionContainers:newStateArray
        })
    }


    onContainerExtending = (msg)=>{
        //console.log('ControllerUnitLayout onContainerExtending')
        let conIDToken = 0
        if(msg.containerExtending)
        {
            if(msg.conID === 0)
            {
                this.setState({
                    containerExtending:{
                        status:msg.containerExtending,
                        conID:msg.conID,
                        //subView:msg.subView
                    },
                    needMousePos:true,
                })
            }
            else
            {
                conIDToken = msg.conID
                this.setState({
                    containerExtending:{
                        status:msg.containerExtending,
                        conID:conIDToken,
                        //subView:msg.subView
                    },
                    needMousePos:true,
                    editToken: !this.state.editToken,
                    editingCompositionID:msg.conID
                })
            }
        }
        else
        {
            this.setState({
                containerExtending:{
                    status:false,
                    conID:conIDToken,
                    //subView:'nonSubView'
                },
                needMousePos:false,
                mousePos:{
                    x:0,
                    y:0
                },
                compositionContainers:this.updateCompositionContainersForSize(msg)
            })
        }
    }

    onContainerDragging = (msg) => {
        //console.log('ControllerUnitLayout onContainerDragging')
        //console.log('conID : ',msg.conID, 'booling : ',msg.containerDragging)
        //console.log(msg.position)
        let conIDToken = 0
        if(msg.containerDragging)
        {
            if(msg.conID === 0 )
            {
                this.setState({
                    containerDragging:{
                        status:msg.containerDragging,
                        conID:msg.conID
                    },
                    needMousePos:true,
                })
            }
            else
            {
                //console.log('onContainerDragging true')
                this.setState({
                    containerDragging:{
                        status:msg.containerDragging,
                        conID:msg.conID
                    },
                    needMousePos:true,
                    editToken: !this.state.editToken,
                    editingCompositionID:msg.conID
                })
            }
        }
        else
        {
            let tempFullHeight = 0 
            let tempNotFullHeight = 0
            //console.log(this.scrollContainerLayout.scrollHeight)
            
            if(this.scrollContainerLayout.scrollHeight > 800)
            {
                tempFullHeight = this.scrollContainerLayout.scrollHeight
                tempNotFullHeight = this.scrollContainerLayout.scrollHeight
            }
            else if( 800 >= this.scrollContainerLayout.scrollHeight && this.scrollContainerLayout.scrollHeight > 600)
            {
                tempFullHeight = 800
                tempNotFullHeight = this.scrollContainerLayout.scrollHeight
            }
            else if(600 >= this.scrollContainerLayout.scrollHeight)
            {
                tempFullHeight = 800
                tempNotFullHeight = 600
            }
            
            this.setState({
                layoutHeightNotFull:tempNotFullHeight,
                layoutHeightFull:tempFullHeight,
                EditFloatWindowPos:msg.position,
                containerDragging:{
                    status:false,
                    conID:conIDToken
                },
                needMousePos:false,
                mousePos:{
                    x:0,
                    y:0
                },
                compositionContainers:this.updateCompositionContainersForPos(msg)

            })
        }
    }

    updateCompositionContainersForSize=(msg)=>{
        let tempArray=[]
        this.state.compositionContainers.forEach(container=>{
            if(container.conID === msg.conID)
            {
                let tempContainer = {}
                tempContainer = container
                tempContainer.width = msg.size.width
                tempContainer.height = msg.size.height
                tempArray.push(tempContainer)
            }
            else
            {
                tempArray.push(container)
            }
        })
        return tempArray
    }

    updateCompositionContainersForPos=(msg)=>{
        let tempArray=[]
        this.state.compositionContainers.forEach(container=>{
            if(container.conID === msg.conID)
            {
                let tempContainer = {}
                tempContainer = container
                tempContainer.x = msg.position.x
                tempContainer.y = msg.position.y
                tempArray.push(tempContainer)
            }
            else
            {
                tempArray.push(container)
            }
        })
        return tempArray
    }

    listCompositionContainer=()=>{
        let output = []
        if(this.state.compositionContainers)
        {
            this.state.compositionContainers.forEach(container=>{
                let tempObj = {
                    conID:container.conID,
                    type:container.type,
                    title:container.title
                }
                output.push(tempObj)
            })
        }
        return output
    }

    infoEditingComposition=()=>{
        let output = null
        this.state.compositionContainers.forEach(container=>{
            if(container.conID === this.state.editingCompositionID)
            {
                output = container
            }
        })
        return output
    }

    onMouseMove=(e)=>{
        //console.log("ComponentLayot onMouseMove...")
        if(this.state.needMousePos)
        { 
            this.setState({
                mousePos:{
                    x:e.clientX,
                    y:e.clientY
                },
            })
        }
    }

    onContextMenu=(e)=>{
        e.preventDefault()
        let mousePos={
            x:e.clientX,
            y:e.clientY
        }

        this.setState({
            contextManu:{
                status:true,
                pos:mousePos,
                conID:this.state.contextManu.conID,
                command:this.state.contextManu.command,
                from:"contentBody"
            }
        })
    }

    onClick=(e)=>{
        e.stopPropagation()
        this.getCommand("cancel")
    }

    getCompositionChangedInfo=(msg)=>{
        let tempArray=[]
        this.state.compositionContainers.forEach(container=>{
            if(container.conID === msg.conID)
            {
                tempArray.push(msg)
            }
            else
            {
                tempArray.push(container)
            }
        })
        
        this.setState({
            compositionContainers:tempArray
        })
    }

    getEditingCompositionID=(msg)=>{
        if(this.state.editingCompositionID !== msg)
        {
            this.setState({
                editingCompositionID : msg
            })
        }
    }

    resetCompositionContainers=(msg,type)=>{
        let output = []

        if(type === "image")
        {
            if(this.state.compositionContainers)
            {
                this.state.compositionContainers.forEach(container=>{
                    if(container.conID === msg.conID){
                        let tempObj = {
                            commonAttributes:container.commonAttributes,
                            conID:container.conID,
                            width:msg.imageDetails.imageContainerSize.width,
                            height:msg.imageDetails.imageContainerSize.height,
                            x:container.x,
                            y:container.y,
                            imageAttributes:msg.imageDetails,
                            textAttributes:container.textAttributes,
                            title:container.title,
                            type:container.type,
                            zIndex:container.zIndex
                        }
                        output.push(tempObj)
                    }
                    else
                    {
                        output.push(container)
                    }
                })
            }
        }
        else if(type === "text")
        {
            if(this.state.compositionContainers)
            {
                this.state.compositionContainers.forEach(container=>{
                    if(container.conID === msg.conID){
                        let tempObj = {
                            commonAttributes:container.commonAttributes,
                            conID:container.conID,
                            width:container.width,
                            height:container.height,
                            x:container.x,
                            y:container.y,
                            imageAttributes:container.imageAttributes,
                            textAttributes:msg.textDetails,
                            title:container.title,
                            type:container.type,
                            zIndex:container.zIndex
                        }
                        output.push(tempObj)
                    }
                    else
                    {
                        output.push(container)
                    }
                })
            }
        }

        this.setState({
            showImageEditor:false,
            compositionContainers:output
        })   
    }

    loadImage=()=>{
        let tempObj = this.infoEditingComposition()
        
        if(tempObj)
        {
            return tempObj.imageAttributes
            //return msg
        }
        else
        {
            return null
        }
    }

    loadText=()=>{
        let tempObj = this.infoEditingComposition()
        
        if(tempObj)
        {
            let msg = {
                conID:this.state.editingCompositionID,
                textAttributes:tempObj.textAttributes
            }
            //return tempObj.textAttributes
            return msg
        }
        else
        {
            return null
        }
    }

    loadImageContainerSize=()=>{
        let tempObj = this.infoEditingComposition()
        if(tempObj)
        {
            let imageContainerSize = {
                width:tempObj.width,
                height:tempObj.height
            }
            return imageContainerSize
        }
        else
        {
            return null
        }
    }

    getImage=(msg)=>{
        let outputMsg={
            conID:this.state.editingCompositionID,
            imageDetails:msg
        }
        this.resetCompositionContainers(outputMsg,"image")
    }

    getText=(msg)=>{
        console.log('EditContent getText')
        console.log(msg)
        let outputMsg={
            conID:this.state.editingCompositionID,
            textDetails:msg.textDetails
        }
        this.resetCompositionContainers(outputMsg,"text")
    }

    getTextEditorClose=()=>{
        this.setState({
            showTextEditor:false,
        })
    }

    
    getHyperLink=(sysID)=>{
        this.setState({
            showHyperLinkSelector:false,
            searchWord:null
        },()=>{
            document.execCommand("createLink", false, sysID)
        })
    }

    toggleHyperLinkContainer=()=>{
        this.setState({
            showHyperLinkSelector:false,
            searchWord:null
        })
    }


    render(){
        const {classes} = this.props;

        let containerNotFullScreen = {
            height:this.state.layoutHeightNotFull
        }

        let containerFullScreen = {
            height:this.state.layoutHeightFull,
            top:"165px"
        }

        return (
            <div className={classes.scrollContainer} style={this.props.fullScreen? containerFullScreen:containerNotFullScreen} ref={(refElement)=>{this.scrollContainerLayout=refElement}}  mousePos={this.state.mousePos} onMouseMove={this.onMouseMove} onContextMenu={this.onContextMenu} onClick={this.onClick}>     
                <canvas width={2400} height={this.props.fullScreen? this.state.layoutHeightFull:this.state.layoutHeightNotFull} ref={this.gridCanvas}></canvas>  
                <EditFloatWindow conID={0} color={"yellow"} mousePos={this.state.mousePos} height={"300"} containerExtending={this.onContainerExtending} containerDragging={this.onContainerDragging} addImageContainer={this.addImageContainer} addTextContainer={this.addTextContainer} compositionContainers={this.listCompositionContainer()} editToken={this.state.editToken} invokeImageEditor={this.invokeImageEditor} editingCompositionInfo={this.infoEditingComposition()} getCompositionChangedInfo={this.getCompositionChangedInfo} getEditingCompositionID={this.getEditingCompositionID} getContextMenu={this.getContextMenu}/>
                <ImageEditWindow showImageEditor={this.state.showImageEditor} loadImage={this.loadImage()} loadImageContainerSize={this.loadImageContainerSize()} getImage={this.getImage} closeImageEditor={()=>this.setState({showImageEditor:false})} editImageSize={true}></ImageEditWindow>
               
                {this.state.showHyperLinkSelector?<HyperLinkContainer keyword={this.state.searchWord} getHyperLink={this.getHyperLink} toggleHyperLinkContainer={this.toggleHyperLinkContainer} />:null}
                {this.state.contextManu.status? <ContextMenu pos={this.state.contextManu.pos} prevConID={this.state.contextManu.conID} prevCommand={this.state.contextManu.command} invokeFrom={this.state.contextManu.from} getCommand={this.getCommand}/>:null}
                {this.createContainer()}
            </div>
        )  
    }
}

export default withStyles(wStyles)(EditContent)